import { isArray } from 'lodash';

export const convertMultiRoomToPaxCount = (
  multi_room_guests: { adult: number; child: number; infant: number }[] | string
) => {
  const multiRoomGuestsArray = isArray(multi_room_guests)
    ? multi_room_guests
    : typeof multi_room_guests === 'string'
    ? JSON.parse(multi_room_guests)
    : [];

  const totalPax =
    isArray(multiRoomGuestsArray) &&
    multiRoomGuestsArray?.length > 0 &&
    multiRoomGuestsArray.reduce(
      (acc, curr) => {
        acc.adult += +curr.adult;
        acc.child += +curr.child;
        acc.infant += +curr.infant;
        return acc;
      },
      {
        adult: 0,
        child: 0,
        infant: 0,
      }
    );

  return totalPax;
};
